import { assignmentsList, assignmentStore, assignmentCancel } from '@/services/jobs/test-assignments.service'

export default {
	namespaced: true,
	state: {
		list:       { meta: { pagination: { total: 0 } } },
		listStatus: 'init',
		saveStatus: 'init',
	},
	getters: {
		getList:       state => state.list,
		getListStatus: state => state.listStatus,
		getSaveStatus: state => state.saveStatus,
	},
	mutations: {
		LIST(state, value)        { state.list = value },
		LIST_STATUS(state, value) { state.listStatus = value },
		SAVE_STATUS(state, value) { state.saveStatus = value },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('LIST_STATUS', 'pending')
			commit('LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await assignmentsList(params)
				commit('LIST_STATUS', 'init')
				commit('LIST', data)
				return data
			} catch (error) {
				commit('LIST_STATUS', 'init')
				throw error
			}
		},

		async sendInvite({ commit }, params) {
			commit('SAVE_STATUS', 'pending')
			try {
				const { data } = await assignmentStore(params)
				commit('SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SAVE_STATUS', 'init')
				throw error
			}
		},

		async cancelAssignment({ commit }, id) {
			commit('SAVE_STATUS', 'pending')
			try {
				const { data } = await assignmentCancel(id)
				commit('SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SAVE_STATUS', 'init')
				throw error
			}
		},
	},
}
